module.exports = __webpack_public_path__ + "static/media/ic_remove.8b872020.svg";